import { Component, OnInit } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { FieldType, FieldTypeConfig } from '@ngx-formly/core';
import { InputNumberModule } from 'primeng/inputnumber';

@Component({
    selector: 'formly-primeng-field-number',
    imports: [ReactiveFormsModule, InputNumberModule],
    template: `
        <p-inputnumber mode="decimal" [minFractionDigits]="0" [maxFractionDigits]="5" [id]="key" [formControl]="formControl" fluid/>
    `,
    styles: [
        `
        :host ::ng-deep {
            .p-inputnumber-input {
                width: 100%;
            }
        }
        `
    ]
})

export class InputNumberFieldCosmos extends FieldType<FieldTypeConfig> {

    ngOnInit() { }
}